import React, { PureComponent } from 'react';

interface IImageProps {
  imageName: string;
  altText: string;
  extension?: string;
  classNames?: string[];
}

interface IImageState {
  src: string;
}

export default class StaticImage extends PureComponent<IImageProps, IImageState> {
  private imageRef: React.MutableRefObject<HTMLImageElement>;

  constructor (props: IImageProps) {
    super(props);
    const ext = this.props.extension ? '.' + this.props.extension : '';
    this.state = {
      src: require(`../../../assets/${this.props.imageName}${ext}`)
    };
    this.imageRef = React.createRef();
  }

  componentDidMount () {
    const src = this.imageRef.current.getAttribute('src');
    if (src.indexOf('$staticlink$') === -1 && src.indexOf('http') !== -1) {
      this.setState({ src });
    }
  }

  render () {
    const { altText, classNames } = this.props;
    const { src } = this.state;

    return (
      <img
        className={classNames && classNames.join(' ')}
        ref={this.imageRef}
        src={src}
        alt={altText}
      />
    );
  }
}
